/* eslint-disable */
import Searchbar from './components/search';
import Select from './components/select';
import MultiSelect from './components/multiSelect';
import DatePicker from 'components/DatePicker';
import Button from '../Button';
import { useForm, Controller } from 'react-hook-form';
import { filter, find } from 'lodash';
import PropTypes from 'prop-types';
import { isEmpty, isEqual } from 'lodash';

import translating from '../../translate.json';
import './style.scss';
import { useEffect, useState } from 'react';
import AutocompleteComp from './components/autocomplete';
import { useSearchParams } from 'react-router-dom';

const Filter = ({ fields, data, handleFilter, handleReset, ssf }) => {
  const { reset, register, watch, control } = useForm();
  const [searchParams, setSearchParams] = useSearchParams();

  const watchAllFields = watch();

  const [filtersFields, setFiltersFields] = useState(watchAllFields);
  const searchFun = (item, filters) => {
    for (var index in filters) {
      if (
        filters[index] !== '' &&
        filters[index] !== null &&
        filters[index] !== undefined
      ) {
        let currentField = find(fields, { name: index });

        switch (currentField?.type) {
          case 'search': {
            let searchFound = false;
            currentField.fields?.forEach((searchField, i, currentField) => {
              let tmpFields =
                searchField === 'first_name'
                  ? `${item['first_name']} ${item['last_name']}`
                  : searchField === 'last_name'
                  ? `${item['last_name']} ${item['first_name']}`
                  : item[searchField];
              searchFound = tmpFields
                ?.toString()
                ?.toLowerCase()
                ?.includes(filters[index]?.toLowerCase().trim());
              if (searchFound) currentField.length = i + 1;
            });
            if (!searchFound) {
              return false;
            }
            break;
          }
          case 'select':
            const filterValue = String(filters[index]);
            const itemValue = String(item?.[currentField.name]);

            if (
              filterValue !== 'all' &&
              filterValue !== translating.all &&
              itemValue !== filterValue
            ) {
              return false;
            }
            break;
          case 'autocomplete':
            if (
              filters[index] &&
              filters[index] !== 'all' &&
              filters[index] !== translating.all &&
              String(item?.[currentField.name]) !== String(filters[index])
            ) {
              return false;
            }
            break;
          case 'multiselect':
            if (
              filters[index] !== 'all' &&
              !isEmpty(filters[index]) &&
              filters[index] !== translating.all &&
              !filters[index].includes(String(item?.[currentField?.name])) &&
              !filters[index].includes(
                String(item?.[currentField?.name]?.[currentField?.subField])
              )
            ) {
              return false;
            }
            break;
          case 'date':
            if (filters[index] !== null) {
              if (currentField.subType === 'toDate') {
                if (
                  new Date(item?.[currentField?.field]) >=
                  new Date(filters[index])
                ) {
                  return false;
                }
              } else if (currentField.subType === 'fromDate') {
                if (
                  new Date(item?.[currentField?.field]) <=
                  new Date(filters[index])
                ) {
                  return false;
                }
              }
            }
            break;
          default:
            break;
        }
      }
    }
    return true;
  };
  useEffect(() => {
    const defaultValues = {};
    for (const [key, value] of searchParams.entries()) {
      // Find the field definition by name
      const field = fields?.find((f) => f.name === key);

      if (field?.type === 'date') {
        // Convert string to Date object for date fields
        defaultValues[key] = new Date(value);
      } else if (field?.type === 'multiselect') {
        // Convert comma-separated string into array for multiselect
        const values = value.split(',').filter((v) => v.trim() !== '');
        defaultValues[key] = values.length > 0 ? values : ['הכל'];
      } else {
        // Use raw string value for all other fields
        defaultValues[key] = value;
      }
    }

    if (Object.keys(defaultValues).length > 0) {
      reset(defaultValues);
    }
  }, [searchParams, fields, reset]);

  const onSubmit = async (filters) => {
    const cleanedParams = {};
    for (const key in filters) {
      const val = filters[key];
      if (val && val !== '' && val !== 'all') {
        const field = fields?.find((f) => f.name === key);

        if (field?.type === 'multiselect') {
          // Convert array to comma-separated string for multiselect
          if (Array.isArray(val) && val.length > 0) {
            cleanedParams[key] = val.join(',');
          }
        } else {
          cleanedParams[key] = val;
        }
      }
    }
    setSearchParams(cleanedParams);
    if (ssf && (filters.fromDate !== '' || filters.toDate !== '')) {
      data = await ssf(filters);
      data = data.data;
    } else
      data = data?.filter((t) => {
        return searchFun(t, filters);
      });
    setFiltersFields(watchAllFields);
    handleFilter(data);
  };

  // useEffect(() => {
  //   if (!ssf && data?.length && !isEmpty(watchAllFields)) {
  //     onSubmit(watchAllFields);
  //   }
  // }, [data]);

  useEffect(() => {
    if (
      !ssf &&
      !isEmpty(watchAllFields) &&
      !isEqual(watchAllFields, filtersFields)
    ) {
      onSubmit(watchAllFields);
    }
  }, [watchAllFields, filtersFields]);

  return (
    <div>
      {fields?.length ? (
        <form className="filters">
          <div className="wrapper-filters-inputs">
            {fields?.map((field) =>
              (() => {
                switch (field?.type) {
                  case 'search':
                    return (
                      <Searchbar field={field} register={register}></Searchbar>
                    );
                  case 'autocomplete':
                    return (
                      <AutocompleteComp
                        Controller={Controller}
                        control={control}
                        field={field}
                      ></AutocompleteComp>
                    );
                  case 'select':
                    return (
                      <Select
                        Controller={Controller}
                        control={control}
                        field={field}
                      ></Select>
                    );
                  case 'multiselect':
                    return (
                      <MultiSelect
                        Controller={Controller}
                        control={control}
                        field={field}
                      ></MultiSelect>
                    );
                  case 'date':
                    return (
                      <DatePicker
                        Controller={Controller}
                        control={control}
                        field={field}
                        showLabel={true}
                      ></DatePicker>
                    );
                  default:
                    return <div></div>;
                }
              })()
            )}
          </div>
          <div className="wrapper-btns">
            <Button
              txt={translating.resetFilters}
              handleClick={() => {
                reset();
                setFiltersFields({});
                handleReset();
              }}
              variant="text"
            ></Button>
            {ssf && (
              <Button
                txt={translating.filter}
                handleClick={() => {
                  onSubmit(watchAllFields);
                }}
                variant="text"
              ></Button>
            )}
          </div>
        </form>
      ) : (
        <div>no fields to filter</div>
      )}
    </div>
  );
};

export default Filter;

Filter.propTypes = {
  fields: PropTypes.array,
  data: PropTypes.object,
  handleFilter: PropTypes.func,
  handleReset: PropTypes.func,
  ssf: PropTypes.func
};
